// frontend/src/app/not-found.tsx
'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

export default function NotFound() {
  const t = useTranslations('notFound');

  return (
    <main className="min-h-[80vh] flex flex-col items-center justify-center px-4 text-center">

      {/* Kitten with yarn — inline SVG illustration */}
      <div className="mb-6 select-none" aria-hidden="true">
        <svg width="180" height="160" viewBox="0 0 180 160" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Body */}
          <ellipse cx="90" cy="118" rx="38" ry="28" fill="#c8e6c9" />
          {/* Head */}
          <circle cx="90" cy="78" r="28" fill="#c8e6c9" />
          {/* Left ear */}
          <polygon points="68,56 60,36 80,52" fill="#c8e6c9" />
          <polygon points="70,54 63,40 78,52" fill="#f8bbd0" />
          {/* Right ear */}
          <polygon points="112,56 120,36 100,52" fill="#c8e6c9" />
          <polygon points="110,54 117,40 102,52" fill="#f8bbd0" />
          {/* Eyes */}
          <ellipse cx="80" cy="76" rx="5" ry="6" fill="#1a2e1f" />
          <ellipse cx="100" cy="76" rx="5" ry="6" fill="#1a2e1f" />
          {/* Eye shine */}
          <circle cx="82" cy="74" r="1.5" fill="white" />
          <circle cx="102" cy="74" r="1.5" fill="white" />
          {/* Nose */}
          <ellipse cx="90" cy="85" rx="3" ry="2" fill="#f8bbd0" />
          {/* Mouth */}
          <path d="M87 87 Q90 91 93 87" stroke="#6b8c7a" strokeWidth="1.2" fill="none" strokeLinecap="round" />
          {/* Whiskers left */}
          <line x1="68" y1="84" x2="84" y2="86" stroke="#6b8c7a" strokeWidth="1" strokeLinecap="round" />
          <line x1="66" y1="88" x2="83" y2="88" stroke="#6b8c7a" strokeWidth="1" strokeLinecap="round" />
          {/* Whiskers right */}
          <line x1="112" y1="84" x2="96" y2="86" stroke="#6b8c7a" strokeWidth="1" strokeLinecap="round" />
          <line x1="114" y1="88" x2="97" y2="88" stroke="#6b8c7a" strokeWidth="1" strokeLinecap="round" />
          {/* Front paws */}
          <ellipse cx="70" cy="142" rx="14" ry="8" fill="#c8e6c9" />
          <ellipse cx="110" cy="142" rx="14" ry="8" fill="#c8e6c9" />
          {/* Paw toes left */}
          <ellipse cx="62" cy="146" rx="4" ry="3" fill="#b2dfdb" />
          <ellipse cx="70" cy="148" rx="4" ry="3" fill="#b2dfdb" />
          <ellipse cx="78" cy="146" rx="4" ry="3" fill="#b2dfdb" />
          {/* Paw toes right */}
          <ellipse cx="102" cy="146" rx="4" ry="3" fill="#b2dfdb" />
          <ellipse cx="110" cy="148" rx="4" ry="3" fill="#b2dfdb" />
          <ellipse cx="118" cy="146" rx="4" ry="3" fill="#b2dfdb" />
          {/* Tail */}
          <path d="M128 118 Q155 100 148 130 Q145 144 132 138" stroke="#c8e6c9" strokeWidth="10" fill="none" strokeLinecap="round" />
          {/* Ball of yarn */}
          <circle cx="148" cy="138" r="16" fill="#2d7a4f" opacity="0.85" />
          <circle cx="148" cy="138" r="16" fill="none" stroke="#1a2e1f" strokeWidth="0.5" opacity="0.2" />
          {/* Yarn lines */}
          <path d="M136 130 Q148 122 160 132" stroke="white" strokeWidth="1.2" fill="none" opacity="0.5" strokeLinecap="round" />
          <path d="M134 138 Q148 130 162 138" stroke="white" strokeWidth="1.2" fill="none" opacity="0.5" strokeLinecap="round" />
          <path d="M136 146 Q148 138 160 144" stroke="white" strokeWidth="1.2" fill="none" opacity="0.5" strokeLinecap="round" />
          {/* Yarn string to paw */}
          <path d="M132 138 Q120 140 110 142" stroke="#2d7a4f" strokeWidth="1.5" fill="none" strokeLinecap="round" />
          {/* Stripes on head */}
          <path d="M84 56 Q87 62 85 68" stroke="#a5d6a7" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.7" />
          <path d="M90 54 Q90 60 90 66" stroke="#a5d6a7" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.7" />
          <path d="M96 56 Q93 62 95 68" stroke="#a5d6a7" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.7" />
        </svg>
      </div>

      <h1 className="text-6xl font-bold text-[#2d7a4f] mb-2">404</h1>
      <h2 className="text-xl font-semibold text-[#1a2e1f] mb-3">{t('title')}</h2>
      <p className="text-[#6b8c7a] text-sm max-w-xs mb-8">
        {t('body')}
      </p>

      <div className="flex gap-3">
        <Link
          href="/"
          className="px-5 py-2.5 bg-[#2d7a4f] text-white rounded-lg text-sm font-medium hover:bg-[#235f3d] transition"
        >
          {t('backHome')}
        </Link>
        <Link
          href="/browse?region=western-slope"
          className="px-5 py-2.5 border border-[#2d7a4f] text-[#2d7a4f] rounded-lg text-sm font-medium hover:bg-[#e8f5e9] transition"
        >
          {t('browseProducts')}
        </Link>
      </div>

    </main>
  );
}
